import { render, staticRenderFns } from "./confirmOrder.vue?vue&type=template&id=1c33ae88&scoped=true&"
import script from "./confirmOrder.vue?vue&type=script&lang=js&"
export * from "./confirmOrder.vue?vue&type=script&lang=js&"
import style0 from "./confirmOrder.vue?vue&type=style&index=0&id=1c33ae88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c33ae88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\胶己人\\jjr_store_reservation\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c33ae88')) {
      api.createRecord('1c33ae88', component.options)
    } else {
      api.reload('1c33ae88', component.options)
    }
    module.hot.accept("./confirmOrder.vue?vue&type=template&id=1c33ae88&scoped=true&", function () {
      api.rerender('1c33ae88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/confirmOrder.vue"
export default component.exports